import { makeStyles, Typography } from '@material-ui/core';
import { KeyboardArrowRight } from '@material-ui/icons';
import React from 'react';

import { FontSizes } from '../../../../../../core/config/mainTheme';
import {
  useConnectionsDispatch,
  useConnectionsState,
} from '../ConnectionsContext/ConnectionsContext';
import {
  ConnectionsContextActionTypes,
  Path,
} from '../ConnectionsContext/ConnectionsContext.types';

interface Props {}

const ConnectionDisplayNavigation: React.FC<Props> = () => {
  const classes = useStyles();
  const { path } = useConnectionsState();
  const dispatch = useConnectionsDispatch();

  const onClickHandle = (id: string, pathIdx: number) => {
    dispatch({
      type: ConnectionsContextActionTypes.SetCompanyId,
      payload: id,
    });
    dispatch({
      type: ConnectionsContextActionTypes.NavigateToPath,
      payload: pathIdx,
    });
  };

  const navigationElement = (p: Path, index: number, hasMoreElements: boolean) => (
    <Typography
      key={p.id + index}
      onClick={() => onClickHandle(p.id, index)}
      className={`${classes.backlink} ${index + 1 === path.length ? 'bold' : ''}`}
    >
      {index > 0 ? <KeyboardArrowRight /> : ''} {p.name}
      {hasMoreElements ? (
        <>
          <KeyboardArrowRight />
          ...
        </>
      ) : (
        ''
      )}
    </Typography>
  );

  const shouldSliceElements = path.length >= 10;
  const navigations = path.map((p, index) =>
    navigationElement(p, index, shouldSliceElements && index === 0),
  );

  return (
    <>
      {shouldSliceElements
        ? navigations.slice(0, 1).concat(navigations.slice(path.length - 8))
        : navigations}
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  backlink: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    textDecoration: 'none',
    textTransform: 'uppercase',
    color: theme.palette.secondary.dark,
    fontSize: FontSizes.size.smallest,
    marginRight: theme.spacing(2),
    cursor: 'pointer',
    '& .MuiSvgIcon-root': {
      marginRight: theme.spacing(2),
      width: theme.spacing(8),
    },
    '&.bold': {
      fontWeight: 'bold',
    },
  },
}));

export default ConnectionDisplayNavigation;
